<template>
  <v-layout row wrap style="margin: 0px -8px !important;">
    <v-flex xs12 sm6 lg3 class="pa-2" v-for="card in topStats" :key="card.label">
      <StatCard :card="card" />
    </v-flex>
    <v-flex xs12 sm6 lg3 class="pa-2" v-for="card in midStats" :key="card.label">
      <StatCard :card="card" />
    </v-flex>
    <v-flex xs12 sm6 lg3 class="pa-2" v-for="card in bottomStats" :key="card.label">
      <StatCard :card="card" />
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'
import { URL } from '../../../env'
import StatCard from './StatCard'

export default {
  components: {
    StatCard,
  },
  props: {
    syndicationId: { default: null },
  },
  data() {
    return {
      syndication_id: this.syndicationId || localStorage.getItem('syndication_id'),
      user_id: localStorage.getItem('user_id'),
      stats: {
        capital_participated: 0,
        expected_rtr: 0,
        projected_profit: 0,
        actual_profit: 0,
        collected_to_date: null,
        outstanding_balance: 0,
        payout_due: 0,
        plugged_daily_payment: null,
        cash_balance: 0,
        active_deals: 0,
        collection_deals: 0,
        default_deals: 0,
        completed_deals: 0,
      },
    };
  },
  mounted() {
    this.getSuperSyndicateStats();
  },
  watch: {
    syndicationId: function (id) {
      this.syndication_id = id;
      this.getSuperSyndicateStats();
    },
  },
  computed: {
    topStats: function () { return [
      { icon:'attach_money', label:'Capital Participated', value:this.stats.capital_participated, currency:true, tone:'blue', positive:true },
      { icon:'gps_fixed', label:'Expected RTR', value:this.stats.expected_rtr, currency:true, tone:'violet', positive:true },
      { icon:'trending_up', label:'Projected Profit', value:this.stats.projected_profit, currency:true, tone:'green', positive:true },
      { icon:'receipt', label:'Actual Profit', value:this.stats.actual_profit, currency:true, tone:'green', positive:true }
    ]; },
    midStats: function () { return [
      { icon:'account_balance_wallet', label:'Collected to Date', value:this.stats.collected_to_date, currency:true, tone:'green', positive:true },
      { icon:'pie_chart', label:'Outstanding Balance', value:this.stats.outstanding_balance, currency:true, tone:'amber', positive:true },
      { icon:'account_balance', label:'Total Payouts', value:this.stats.payout_due, currency:true, tone:'blue', positive:true },
      { icon:'account_balance_wallet', label:'Cash Balance', value:this.stats.cash_balance, currency:true, tone:'blue', positive:true }
    ]; },
    bottomStats: function () { return [
      { icon:'layers', label:'Active Deals', value:this.stats.active_deals, currency:false, tone:'slate', positive:true },
      { icon:'rule', label:'Collection Deals', value:this.stats.collection_deals, currency:false, tone:'amber', positive:true },
      { icon:'warning', label:'Defaults', value:this.stats.default_deals, currency:false, tone:'rose', positive:false },
      { icon:'check_circle', label:'Completed Deals', value:this.stats.completed_deals, currency:false, tone:'green', positive:true }
    ]; },
  },
  methods: {
    getSuperSyndicateStats: function () {
      if (!this.syndication_id) return;
      axios.get(`${URL}/api/payouts/super_syndicate_stats/${this.syndication_id}`, {
        params: { user_id: this.user_id }
      }).then(res => { this.stats = res.data; });
    },
  },
};
</script>

<style scoped src="./Styles/SuperSyndicate.css"></style>
